// extracted by mini-css-extract-plugin
module.exports = {"search":"SearchInput_search__RSayY"};